import React, { useState, useEffect } from "react";
import { Snackbar, SnackbarContent } from "@mui/material";
import {
  Error as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import theme from "../../Styles/theme";

const variantIcon = {
  ERRO: ErrorIcon,
  ATENCAO: WarningIcon,
  SUCESSO: CheckCircleIcon,
  AVISO: InfoIcon,
};

export interface Notificacao {
  mensagem: string;
  tipo: "ERRO" | "ATENCAO" | "SUCESSO" | "AVISO";
}

interface Props {
  notificacao: Notificacao;
  setNotificacao: React.Dispatch<React.SetStateAction<Notificacao>>;
}

export const NotificacaoComponent = ({ notificacao, setNotificacao }: Props) => {
  const [open, setOpen] = useState(false);
  const time = 15000

  useEffect(() => {
    if (notificacao.mensagem.length > 0) {
      setOpen(true);
      const timer = setTimeout(() => {
        handleClose();
      }, time); // Fechar após 5 segundos
      return () => clearTimeout(timer);
    }
  }, [notificacao]);

  const handleClose = () => {
    setNotificacao({tipo:"AVISO",mensagem:""})
    setOpen(false);
  };

  const Icon = variantIcon[notificacao.tipo];

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={open}
      autoHideDuration={time}
      onClose={() => {
        handleClose();
      }}
    >
      <SnackbarContent
        style={{
          backgroundColor:
            notificacao.tipo === "ERRO"
              ? theme.colors.attention
              : notificacao.tipo === "SUCESSO"
              ? theme.colors.success
              : notificacao.tipo === "AVISO"
              ? theme.colors.information
              : theme.colors.alert,
        }}
        message={
          <div style={{ display: "flex", alignItems: "center" }}>
            {Icon && <Icon style={{ marginRight: "8px" }} />}
            <span>{notificacao.mensagem}</span>
          </div>
        }
        action={null}
      />
    </Snackbar>
  );
};

// NotificacaoComponent.propTypes = {
//   mensagem: PropTypes.string.isRequired,
//   tipo: PropTypes.oneOf(["ERRO", "ATENCAO", "SUCESSO", "AVISO"]).isRequired,
// };
